import { LifeChoicePageContext } from 'context/lifeChoice'
import { useContext } from 'react'

export const useLifeChoicePageContext = () => useContext(LifeChoicePageContext)